import * as Sentry from "@sentry/react";

/**
 * Sentry for the customer portal.
 *
 * No-op unless `VITE_SENTRY_DSN` is set. The DSN is public (browser-side ingest
 * only) and is committed in `.env.production`, because this app is built on the
 * operator's machine rather than in CI. Events carry `app=portal` so they sort
 * apart from the dashboard's in the shared project; default PII stays off.
 */
export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) || import.meta.env.MODE,
    sendDefaultPii: false,
    initialScope: { tags: { app: "portal" } },
  });
}

/** Report a caught error; a no-op when Sentry was never initialised. */
export function reportError(error: unknown, context?: Record<string, unknown>): void {
  Sentry.captureException(error, context ? { extra: context } : undefined);
}
